import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CheckoutSuccessComponentDef } from '@df/checkout/checkout-success.component.def';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { NSamplesCheckoutSuccessCms } from './samples-checkout-success-cms.component';
@Component({
    selector: 'samples-checkout-success',
    templateUrl: './samples-checkout-success.html',
    styleUrls: ['./samples-checkout-success.scss'],
    standalone: true,
    imports: [ICmsClientModule, TranslationModule, SizeClassDirective, CommonModule, RouterLink]
})
export class SamplesCheckoutSuccessComponent extends CheckoutSuccessComponentDef implements OnInit {
    @Input()
    content?: NSamplesCheckoutSuccessCms.IBlockDataContent;
}
